// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jf-0";
export var animationContainer = "_jf-1";
export var modalContent = "_jf-2";
export var orderName = "_jf-3";
export var refundOption = "_jf-4";
export var refundOptionsContainer = "_jf-5";